// Source unique du numéro de version affiché dans l'interface.
//
// Il a existé trois valeurs concurrentes : « v3.7 • © 2025 » sur la page de
// connexion, « v3.0 » dans le bandeau latéral, « 3.1.0 » dans la documentation.
// Un prospect qui voit deux numéros dans la même session se demande lequel est
// le vrai — et la couture apparente se remarque plus que la version elle-même.
// Toute nouvelle mention de la version DOIT importer cette constante.
export const APP_VERSION = '3.2';
export const APP_COPYRIGHT_YEAR = '2026';
